<template>
  <div class="bodyBox">
    <div class="silder-box">
      <el-menu
        default-active="1"
        class="el-menu-vertical-demo"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
        :router="true"
      >
        <el-menu-item index="1" route="gdp">
          <i class="el-icon-menu"></i>
          <span slot="title">人口与GDP</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="main-box">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.bodyBox {
  height: 100%;
  width: 100%;
  /* background-color: aqua; */
  display: flex;
}
.silder-box {
  width: 10%;
  height: 100%;
  background-color: #434a50;
}
.main-box {
  /* background-color: rgb(62, 9, 154); */
  width: 90%;
  height: 100%;
}
</style>